import React, { useState, useEffect } from 'react';
import { a2aAdminService } from '../../a2a/services/a2aAdminService.js';
import './AnalyticsModule.css';

const AnalyticsModule = ({ currentUser, onBack, onTabChange }) => {
  const [analytics, setAnalytics] = useState({});
  const [dateRange, setDateRange] = useState({ start: '', end: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchAnalytics();
  }, [dateRange]);

  const fetchAnalytics = async () => {
    setLoading(true);
    setError('');
    try {
      const tenantId = currentUser?.tenant_id || 'tn_01';
      const result = await a2aAdminService.getSystemAnalytics({
        tenant_id: tenantId,
        ...dateRange
      });
      if (result.success) {
        setAnalytics(result.data || {});
      } else {
        setError(result.error || 'Failed to fetch analytics');
      }
    } catch (err) {
      setError(err.message || 'An error occurred');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="analytics-module">
      <div className="module-header">
        <button className="back-button" onClick={onBack}>← 返回</button>
        <h2>分析報表</h2>
        <div className="date-range">
          <input
            type="date"
            value={dateRange.start}
            onChange={(e) => setDateRange({...dateRange, start: e.target.value})}
            placeholder="開始日期"
          />
          <span>至</span>
          <input
            type="date"
            value={dateRange.end}
            onChange={(e) => setDateRange({...dateRange, end: e.target.value})}
            placeholder="結束日期"
          />
        </div>
      </div>
      
      {error && <div className="error-message">{error}</div>}
      
      {loading ? (
        <div className="loading">載入中...</div>
      ) : (
        <div className="analytics-dashboard">
          <div className="analytics-cards">
            <AnalyticsCard 
              title="用戶總數" 
              value={analytics.total_users || 0}
              icon="👥"
            />
            <AnalyticsCard 
              title="活躍用戶" 
              value={analytics.active_users || 0}
              icon="✅"
            />
            <AnalyticsCard 
              title="系統使用率" 
              value={`${analytics.usage_rate || 0}%`}
              icon="📊"
            />
            <AnalyticsCard 
              title="錯誤率" 
              value={`${analytics.error_rate || 0}%`}
              icon="⚠️"
            />
          </div>
          
          <div className="analytics-charts">
            <div className="chart-placeholder">
              <h3>用戶增長圖表</h3>
              <p>User Growth Chart - Coming Soon</p>
              {analytics.user_growth && analytics.user_growth.length > 0 ? (
                <pre>{JSON.stringify(analytics.user_growth, null, 2)}</pre>
              ) : (
                <p className="no-data">暫無數據</p>
              )}
            </div>
            
            <div className="chart-placeholder">
              <h3>功能使用圖表</h3>
              <p>Feature Usage Chart - Coming Soon</p>
              {analytics.feature_usage && analytics.feature_usage.length > 0 ? (
                <pre>{JSON.stringify(analytics.feature_usage, null, 2)}</pre>
              ) : (
                <p className="no-data">暫無數據</p>
              )}
            </div>
            
            <div className="chart-placeholder">
              <h3>系統性能圖表</h3>
              <p>System Performance Chart - Coming Soon</p>
              {analytics.performance && analytics.performance.length > 0 ? (
                <pre>{JSON.stringify(analytics.performance, null, 2)}</pre>
              ) : (
                <p className="no-data">暫無數據</p>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// Analytics Card Component
const AnalyticsCard = ({ title, value, icon }) => {
  return (
    <div className="analytics-card">
      <div className="card-icon">{icon}</div>
      <div className="card-content">
        <div className="card-title">{title}</div>
        <div className="card-value">{value}</div>
      </div>
    </div>
  );
};

export default AnalyticsModule;

